/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { companyDetailsValidationUrl } from '@well/navigation';
import { LoggedInContextService } from '@well/shared-providers';
import { Rights } from '@well/rights';

export const companyDetailsValidatedGuard: CanMatchFn = () => {
  const router = inject(Router);
  const returnUrl = router.getCurrentNavigation()?.initialUrl.toString();
  const whitelistAuthType = ['authPasswordRecovery', 'authEmailConfirmation'];
  const contextService = inject(LoggedInContextService);

  return contextService.userContext$.pipe(
    map((loggedInContext) => {
      const { loggedInUser, companyDetailsValidated } = loggedInContext;

      const isWhitelistedAuthType = whitelistAuthType.includes(loggedInUser?.authType ?? '');
      const hasAdminRight = loggedInUser?.authorities?.includes(Rights.ROLE_ADMIN) ?? false;
      const isPlatformAdmin = loggedInUser?.authorities?.includes(Rights.ROLE_SELECT_ITEMS_ADMIN) ?? false;

      if (!isWhitelistedAuthType && !hasAdminRight && !isPlatformAdmin) {
        if (companyDetailsValidated) {
          return true;
        } else {
          router.navigate(companyDetailsValidationUrl, {
            queryParams: { returnUrl: returnUrl },
            queryParamsHandling: 'merge',
          });
          return false;
        }
      }

      return true;
    })
  );
};
